import React from 'react'
import useTranslationHook from '../hooks/useTranslationHook';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { handleVerificationStep } from '../../redux/action/verificationAction';
import { consumedInvitationToken } from '../../redux/action/buyerAction';

function KycSuccessPrivateAuction() {
    const { t } = useTranslationHook();
    const privateAuctionDetails = useSelector((state) => state.buyer.privateAuctionDetails);
    const lang = useSelector((state) => state.translation.lang);
    const dispatch = useDispatch()

    const handleViewPrivateAuction = () => {
        if (privateAuctionDetails?.token) {
            dispatch(consumedInvitationToken(privateAuctionDetails.token)).catch((err) => {
                console.error(err);
            });
        }
    };

    return (
        <div className="private-auction-pro">
            <div className="container">
                <div className="row justify-content-md-center">
                    <div className="col-lg-7">
                        <div className='box'>
                            <div className='pb-4'>
                                <img src="/img/check-L.svg" alt="" />
                            </div>

                            <h2>
                                {t("You're Invited to a Private Auction!")}
                            </h2>

                            <p className='lightgray-text pb20'>
                                {t("Your account has been created successfully. Complete your KYC verification or explore the private auction details to continue.")}
                            </p>


                            <div className="d-flex gap-3 justify-content-center flex-wrap">
                                <Link
                                    to="/verify"
                                    onClick={() => {
                                        dispatch(handleVerificationStep(2))
                                    }}
                                    className="btn btn-primary"
                                >
                                    {t("Proceed to KYC Verification")}
                                </Link>

                                <Link
                                    to={`/property/detail/${privateAuctionDetails?.property_id}`}
                                    onClick={handleViewPrivateAuction}
                                    className="btn btn-primary"
                                >
                                    {t("View Private Auction")}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default KycSuccessPrivateAuction